import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

  public isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  constructor(private http: HttpClient, private cookies: CookieService, private router: Router) { }

  loginWithAnt() {
    const antUrl = `${environment.antRedirect}`;
    // const antUrl = `${environment.antRedirectUat}`;
   // const antUrl = `${environment.antRedirectdr}`;
  //  const antUrl = `${environment.antRedirectdev}`;
    window.open(antUrl, "_self");
  }

  logout(code: any): Observable<any> {
    return this.http.post('/logout', null, { params: {code: code}});
  }

  loginClientDetail(): Observable<any> {
    return this.http.get('/loginList');
  }

  errorLog(formData: any): Observable<any> {
    return this.http.post('/errorLog', formData);
  }

  populate() {
    if (this.cookies.check('encryptedUserSession')) {
      this.isAuthenticatedSubject.next(true);
      if (window.location.pathname === '/' && window.location.href === environment.pathUrl) {
        this.router.navigateByUrl('/dashboard');
      }
    } else {
      this.isAuthenticatedSubject.next(false);
    }
  }

  purgeAuth() {
    this.sessionDestory();
  }

  /** Clears localStorage, sessionStorage, and cookies (all paths/domains we can reach). */
  clearClientStorage(): void {
    try {
      localStorage.clear();
    } catch {
      // ignore
    }

    try {
      sessionStorage.clear();
    } catch {
      // ignore
    }

    try {
      this.cookies.deleteAll('/');
      this.cookies.deleteAll();
    } catch {
      // ignore
    }

    try {
      const cookieList = document.cookie ? document.cookie.split(';') : [];
      const hostname = window.location.hostname;
      const parentDomain =
        hostname.split('.').length > 2
          ? '.' + hostname.split('.').slice(-2).join('.')
          : hostname.startsWith('.')
            ? hostname
            : '.' + hostname;

      for (const raw of cookieList) {
        const eqPos = raw.indexOf('=');
        const name = (eqPos > -1 ? raw.slice(0, eqPos) : raw).trim();
        if (!name) {
          continue;
        }
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${hostname}`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${parentDomain}`;
      }
    } catch {
      // ignore
    }
  }

  sessionDestory() {
    this.clearClientStorage();
    this.isAuthenticatedSubject.next(false);
    this.router.navigateByUrl('/');
  }

  getNomineeDetails():Observable<any> {
    return this.http.get('/nomineeCheck')
  }
}
